const About = () => {
  return (
    <main className="px-4 py-8">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl font-semibold">About</h2>
        <p className="leading-7 mt-6">
          Textbox is a simple app I'm building to practice my web development skills.
          Think of it as a toolbox to reach for when working with text, lists, and other data.
          Each tool should be concise, with enough options to be useful and flexible without being overwhelming.
        </p>
        <p className="leading-7 mt-6">
          My plan is to update this app with new tools over time, as I think of useful tools that will provide a fun challenge and keep my skills sharp.
        </p>
      </div>
    </main>
  )
}

export default About
